import PublicNav from "../Components/PublicNav";
import Footer from "../Components/Footer";

const SECTIONS = [
  {
    title: "1. Acceptance of Terms",
    body: "By accessing or using RIRA, you agree to be bound by these Terms of Service and our Privacy Policy. If you do not agree to these terms, please do not use the service.",
  },
  {
    title: "2. Description of Service",
    body: "RIRA is a review intelligence platform that connects to your Google Business Profile to provide AI-powered insights, sentiment analysis, competitor benchmarking, and automated reply drafting. Features vary by subscription plan.",
  },
  {
    title: "3. Account Registration",
    body: "You must provide accurate and complete information when creating an account. You are responsible for maintaining the security of your account credentials. You must immediately notify us of any unauthorized access to your account.",
  },
  {
    title: "4. Subscriptions and Billing",
    body: "Paid plans are billed monthly or annually in advance. Prices are listed in USD and may change with 30 days notice. Subscription fees are non-refundable except where required by law. You may cancel at any time; your access continues until the end of the current billing period.",
  },
  {
    title: "5. Acceptable Use",
    body: "You agree not to use RIRA to violate any law, infringe third-party rights, transmit harmful content, or attempt to gain unauthorized access to our systems. We reserve the right to suspend or terminate accounts that violate these restrictions.",
  },
  {
    title: "6. Google Business Profile Integration",
    body: "RIRA integrates with Google Business Profile via Google's official APIs. By connecting your account, you authorize RIRA to access and display your review data and, if enabled, post replies on your behalf. You can revoke this access at any time from your Settings page.",
  },
  {
    title: "7. Intellectual Property",
    body: "RIRA and its original content, features, and functionality are owned by RIRA and protected by applicable intellectual property laws. You retain full ownership of your business data and reviews.",
  },
  {
    title: "8. Disclaimers",
    body: "RIRA is provided 'as is' without warranty of any kind. We do not guarantee that the service will be uninterrupted, error-free, or that AI-generated insights will be accurate in all cases. Use AI-generated content as a starting point and apply your own judgment.",
  },
  {
    title: "9. Limitation of Liability",
    body: "To the fullest extent permitted by law, RIRA shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the service. Our total liability shall not exceed the amount you paid us in the 12 months preceding the claim.",
  },
  {
    title: "10. Changes to Terms",
    body: "We may update these Terms of Service from time to time. We will notify you of significant changes via email or a prominent notice in the app. Continued use of RIRA after changes constitutes acceptance of the updated terms.",
  },
  {
    title: "11. Contact",
    body: "If you have questions about these Terms, please contact us at rirareview@gmail.com.",
  },
];

function TermsPage() {
  return (
    <div className="lp-page">
      <PublicNav />

      <section className="ip-hero">
        <div className="ip-hero-inner">
          <div className="lp-section-label">Legal</div>
          <h1 className="ip-hero-title">Terms of Service</h1>
          <p className="ip-hero-sub">Last updated: May 3, 2026</p>
        </div>
      </section>

      <section className="ip-section">
        <div className="ip-section-inner ip-legal-inner">
          {SECTIONS.map((s) => (
            <div key={s.title} className="ip-legal-section">
              <h2 className="ip-legal-h2">{s.title}</h2>
              <p className="ip-body">{s.body}</p>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default TermsPage;
